import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";

const HeroSectionWebinarBan = () => {
  const sliderData = [
    {
      id: 1,
      title: "",
      img: "assets/images/event-banner/meetup-main-text-new-april.png",
      description: "",
      img2: "assets/images/event-banner/meetup-main-subtext-new-april.png",
      buttonLabel: "View Details",
      buttonLink: "/members-meet-2026",
      buttonLabel2: "Registration Closed",
      buttonLink2: "#",
    },
    // {
    //   id: 2,
    //   title: "Stronger Together",
    //   description:
    //     "Together, we can overcome challenges and achieve greater success. Join us to build a supportive community.",
    //   buttonLabel: "Become a Member",
    //   buttonLink: "/become-a-member#membership-form",
    // },
    // {
    //   id: 3,
    //   title: "Join the Association",
    //   description:
    //     "Become a member today! Gain access to resources, networking, and advocacy that empower your business. Let’s drive change together!",
    //   buttonLabel: "Become a Member",
    //   buttonLink: "/become-a-member#membership-form",
    // },
    // {
    //   id: 4,
    //   title: "Not-for-Profit",
    //   description:
    //     "As a Not-for-Profit, the MSB Association is dedicated to supporting your business. Your membership helps strengthen our community.",
    //   buttonLabel: "Become a Member",
    //   buttonLink: "/become-a-member#membership-form",
    // },
    // {
    //   id: 5,
    //   title: "₤1 Per Day",
    //   description:
    //     "Become a member of the MSB Association and together, we can work towards meaningful change while enjoying the benefits of being together!",
    //   buttonLabel: "Become a Member",
    //   buttonLink: "/become-a-member#membership-form",
    // },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
    }, 1000000);
    return () => clearInterval(interval);
  }, [sliderData.length]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? sliderData.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
  };

  const currentSlide = sliderData[currentIndex];
  const isFirstSlide = currentIndex === 0;

  return (
    <section className="container-fluid banner-custome-padding">
      <style>
        {`
          .btn4 {
            gap: 12px;
            border: 0;
            line-height: 1;
            font-size: 20px;
            overflow: hidden;
            font-weight: 700;
            transition: 300ms;
            position: relative;
            padding: 20px 40px !important;
            align-items: center;
            letter-spacing: 1px;
            display: inline-flex;
            letter-spacing: -0.2px;
            justify-content: center;
            color: white !important;
            background-color: #FBA834 !important;
            border-radius: var(--bs-border-radius-pill) !important;
            text-decoration: none;
            z-index: 1;
          }

          .btn4:before {
            left: 50%;
            bottom: -200%;
            width: 200%;
            height: 200%;
            content: '';
            z-index: -1;
            position: absolute;
            border-radius: 50%;
            transform: translateX(-50%);
            transition: 0.3s ease;
            background-color: #ffffff;
          }

          .btn4.disabled {
            background-color: #cccccc !important;
            color: #666666 !important;
            pointer-events: none;
            cursor: not-allowed;
            box-shadow: none !important;
            transform: none !important;
          }

          .btn4.disabled:before {
            display: none;
          }

          .btn4:hover {
            transform: translateY(-2px);
            color: #FBA834 !important;
            box-shadow: 0 21px 12px 0 rgba(1, 58, 55, 0.13);
          }

          .btn4:hover:before {
            bottom: -70%;
          }

          .btn-view-details {
            gap: 12px;
            border: 2px solid #FBA834;
            line-height: 1;
            font-size: 20px;
            overflow: hidden;
            font-weight: 700;
            transition: 300ms;
            position: relative;
            padding: 18px 38px !important;
            align-items: center;
            letter-spacing: 1px;
            display: inline-flex;
            letter-spacing: -0.2px;
            justify-content: center;
            color: #FBA834 !important;
            background-color: transparent !important;
            border-radius: var(--bs-border-radius-pill) !important;
            text-decoration: none;
            z-index: 1;
          }

          .btn-view-details:hover {
            background-color: #FBA834 !important;
            color: white !important;
            transform: translateY(-2px);
            box-shadow: 0 21px 12px 0 rgba(1, 58, 55, 0.13);
          }
        `}
      </style>
      <div
        className="hero_section hero_financial_consulting parallaxie bg-dark position-relative"
        style={{ padding: isFirstSlide ? "10px 0px 0px 0px" : "" }}
      >
        <div className="row align-items-center">
          {/* Left Side */}
          <div className="col-lg-6">
            <img
              className="msbimgcss"
              src={currentSlide.img}
              alt=""
              style={{
                display: isFirstSlide ? "block" : "none",
                padding: "20px",
              }}
            />

            <motion.h1
              className="hero_title text-dark mb-0"
              key={currentSlide.id}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              transition={{ duration: 0.5 }}
            >
              {currentSlide.title.split(" ").map((word, i) =>
                ["Stronger", "Not-for-Profit", "Association", "₤1"].includes(
                  word
                ) ? (
                  <motion.mark
                    key={i}
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{
                      delay: i * 0.2,
                      duration: 0.5,
                      ease: "easeInOut",
                    }}
                    style={{
                      display: "inline-block",
                      background: "#fff",
                      borderRadius: "10px",
                      marginLeft: "10px",
                    }}
                  >
                    {word}
                  </motion.mark>
                ) : (
                  <span key={i}> {word}</span>
                )
              )}
            </motion.h1>
          </div>

          {/* Right Side */}
          <div className="col-lg-6">
            <motion.p
              key={`${currentSlide.id}-desc`}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.5 }}
              style={{
                marginBottom: isFirstSlide ? "10px" : "",
              }}
            >
              {currentSlide.description}
              {isFirstSlide && currentSlide.img2 && (
                <img
                  src={currentSlide.img2}
                  alt=""
                  className="mb-2"
                  style={{ display: "inline-block", padding: "10px" }}
                />
              )}
            </motion.p>

            {/* Buttons */}
            <div
              className={`d-flex gap-3 flex-wrap sm-justify ${
                isFirstSlide ? "ps-lg-5" : ""
              }`}
            >
              {currentSlide.buttonLabel && (
                <NavLink
                  className="btn-view-details mb-3"
                  to={currentSlide.buttonLink}
                >
                  {currentSlide.buttonLabel}
                </NavLink>
              )}

              {isFirstSlide && currentSlide.buttonLabel2 && (
                <div
                  className="btn4 disabled mb-3"
                >
                  {currentSlide.buttonLabel2}
                </div>
              )}
               {/* {isFirstSlide && currentSlide.buttonLabel2 && (
                <a
                  href={currentSlide.buttonLink2}
                  className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pills btn3"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: "#fff",
                    textDecoration: "none",
                    color: "#333",
                    fontWeight: 600,
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <span
                    style={{
                      background: "#FF0000",
                      borderRadius: "25%",
                      width: "35px",
                      height: "28px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="#fff"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M10 16.5L16 12L10 7.5V16.5Z" />
                    </svg>
                  </span>
                  {currentSlide.buttonLabel2}
                </a>
              )} */}
            </div>
          </div>

          {/* Navigation Arrows */}
          {!isFirstSlide && (
            <div className="w-25 mt-4">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  gap: "10px",
                }}
              >
                <button
                  className="slider-control left-arrow navigation-btns"
                  onClick={handlePrev}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 19L8 12L15 5"
                      stroke="#333"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <button
                  className="slider-control right-arrow navigation-btns"
                  onClick={handleNext}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 5L16 12L9 19"
                      stroke="#333"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroSectionWebinarBan;
